import { PageTitle, Button } from '@components';
import { useNavigate } from 'react-router-dom';
import { useReviewData } from '@hooks';
import { logError } from '@log';
import {
  ErrorCode,
  // MAX_MONEY_LIMIT_FOR_RETURN_METHOD, ONLY_SUPPORTED_OWN_CARRIER, ONLY_OWN_CARRIER_BASE_PLATFORM,
  SHOW_PACKAGE_DIMENSION, SHOW_PACKAGE_DIMENSION_BY_PLATFORM,
} from '@constants';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import { useDispatch, useSelector } from 'react-redux';
import { setReturnMethod } from '@store';
import { useState } from 'react';
import classes from './index.module.css';
import Method from './Method';
import PackageSizeModal from './PackageSizeModal';
import { methods, TITLE_TEXT } from './const';

export const ReturnMethod = () => {
  const navigate = useNavigate();
  const { getReviewData } = useReviewData();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const { merchantId, reviewData = {} } = useSelector((state) => state.claim);
  const { platform } = useSelector((state) => state.policy);
  // $300以上只有seel label ｜｜ 特殊配置的商家只展示own carrier（优先）
  // eslint-disable-next-line no-nested-ternary
  // const returnMethods = (ONLY_SUPPORTED_OWN_CARRIER.includes(merchantId) || ONLY_OWN_CARRIER_BASE_PLATFORM.includes(platform)) ? methods.slice(1, 2) : selectedTotalMoney > MAX_MONEY_LIMIT_FOR_RETURN_METHOD ? methods.slice(0, 1) : methods;

  const handleGetReviewData = async (returnMethod) => {
    try {
      const isSuccess = await getReviewData({ useShippingLabel: returnMethod.value === '1' });
      if (isSuccess) {
        return true;
      }
      return false;
    } catch (error) {
      logError(error);
    }
    return null;
  };
  const handleItemClick = async (returnMethod) => {
    dispatch(setReturnMethod(returnMethod));
    if ((SHOW_PACKAGE_DIMENSION.includes(merchantId) || SHOW_PACKAGE_DIMENSION_BY_PLATFORM.includes(platform)) && returnMethod.value === '1') {
      // 这里只是为了获取GPT尺寸，不管成不成功，都展示弹窗
      await handleGetReviewData(returnMethod);
      setOpen(true);
    } else {
      const isSuccess = await handleGetReviewData(returnMethod);
      if (isSuccess) {
        navigate('../review');
        return;
      }
      navigate('../error', { state: { code: ErrorCode.Wrong } });
    }
  };

  return (
    <div className={classes.wrapper}>
      <PageTitle title={TITLE_TEXT} />
      <div className={classes.content}>
        {methods.map((item) => <Method item={item} key={item.value} handleMethodClick={handleItemClick} />)}
      </div>
      <Button
        variant="outlined"
        startIcon={<ArrowBackRoundedIcon />}
        style={{
          border: '1px solid #BABFC3',
          borderRadius: '2px',
          color: '#202223',
          padding: '8px 16px',
          marginTop: '20px',
          boxShadow: '0px 1px 0px rgba(0, 0, 0, 0.05)',
        }}
        sx={{
          backgroundColor: '#FFFFFF',
          '&:hover': {
            backgroundColor: '#F6F6F7',
          },
        }}
        onClick={() => {
          navigate(-1);
        }}
      >
        Back
      </Button>
      <PackageSizeModal
        open={open}
        setOpen={setOpen}
        data={reviewData.packInfo}
        getReviewData={getReviewData}
        navigate={navigate}
      />
    </div>
  );
};
